export default "__VITE_PUBLIC_ASSET__ade29262__"